// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetInfrastructureRequest,
  TGetInfrastructureModel,
  IMappers,
  TGetInfrastructureResponse_,
  TGetInfrastructureResponse,
  TGetInfrastructureResponse_1,
  TGetInfrastructureResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetInfrastructureModel(parameters: TGetInfrastructureRequest): TGetInfrastructureModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'infrastructure-caching',
    pathApi: '/v4/get-infrastructure/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetInfrastructureOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetInfrastructureRequest;
}

export async function fetchGetInfrastructure<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureOptions<TResponse200, TResponse400>): Promise<
  TGetInfrastructureResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetInfrastructureModel(parameters),
    config,
  )) as FetchResponse<TGetInfrastructureResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetInfrastructureResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetInfrastructureResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetInfrastructureResponse;
}
